import styles from '../BundleSummaryCard.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Bundle } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Button } from 'src/components/Button/Button';
import { ButtonLinkV2 } from 'src/components/Button/ButtonLinkV2';
import { useCart } from 'src/components/Cart/UseCart';
import { FlatEntry } from 'src/services/cms/flattenContentful';

interface BundleSummaryCardButtonProps {
  checkoutLink: FlatEntry<Bundle>['checkoutLink'];
  dcsId: FlatEntry<Bundle>['dcsId'];
}

export const BundleSummaryCardButton: React.FC<BundleSummaryCardButtonProps> = ({ checkoutLink, dcsId }) => {
  const { t } = useTranslation();
  const { cart } = useCart();

  if (!checkoutLink) return null;

  const isBundleAlreadyInCart = dcsId && cart.bundle?.id === dcsId;

  return (
    <div className={styles.bundleSummaryCardBundleCta}>
      {isBundleAlreadyInCart ? (
        <Button
          disabled
          variant={checkoutLink?.variant}
          isFullWidth
          data-test="already-in-cart-btn"
        >
          {t('bundle-summary-card.checkout-cta-already-in-cart')}
        </Button>
      ) : (
        <ButtonLinkV2 entry={checkoutLink} isFullWidth />
      )}
    </div>
  );
};

BundleSummaryCardButton.displayName = 'BundleSummaryCardButton';
